<div class="wrapper-landing-blogs-page">
  <div class="zc-container">
    <div class="grid">
      <div class="grid__s-12">
        <span class="small-title">Blog</span>
      </div>
    </div>
    <div *ngIf="true" class="grid">
      <div class="grid__l-8">
        <div class="wrapper-card-blog large">
          <div class="wrapper-header-card-blog">
            <img src="../../../../assets/images/landing/blogs/image-blog0.png" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label red">
                <span>Igraonica</span>
              </div>
              <span class="time-card-blog">10 min ago</span>
            </div>
            <span class="title-landing-blog-card">Humans are much more smarter than AI</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, 1]">Vidi više</span>
          </div>
        </div>
      </div>
      <div class="grid__l-4">
        <div class="wrapper-banner-blog">
          <!--    TODO JS - Ucitavas banner kao background image kao u primeru ispod      -->
          <!--    TODO JS - Ovo pojavljujes kad postoji banner      -->
          <div *ngIf="false" class="wrapper-image-banner" style="background-image: url('assets/images/landing/blogs/image-blog0.png')"></div>
          <!--    TODO JS - Ovo pojavljujes kad ne postoji banner      -->
          <div *ngIf="true" class="wrapper-banner-empty">
            <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="">
            <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="">
            <div class="content-empty-banner">
              <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="">
              <span>Mesto za</span>
              <span><b>Vašu reklamu!</b></span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div *ngIf="true" class="grid">
      <div class="grid__m-4">
        <div class="wrapper-card-blog">
          <div class="wrapper-header-card-blog">
            <img src="../../../../assets/images/landing/blogs/image-blog1.png" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label red">
                <span>Igraonica</span>
              </div>
              <span class="time-card-blog">10 min ago</span>
            </div>
            <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
            <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, 1]">Vidi više</span>
          </div>
        </div>
      </div>
      <div class="grid__m-4">
        <div class="wrapper-card-blog">
          <div class="wrapper-header-card-blog">
            <img src="../../../../assets/images/landing/blogs/image-blog2.png" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label blue">
                <span>Torte</span>
              </div>
              <span class="time-card-blog">10 min ago</span>
            </div>
            <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
            <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, 1]">Vidi više</span>
          </div>
        </div>
      </div>
      <div class="grid__m-4">
        <div class="wrapper-card-blog">
          <div class="wrapper-header-card-blog">
            <img src="../../../../assets/images/landing/blogs/image-blog3.png" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label green">
                <span>Dekoracija</span>
              </div>
              <span class="time-card-blog">10 min ago</span>
            </div>
            <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
            <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, 1]">Vidi više</span>
          </div>
        </div>
      </div>
      <div class="grid__m-4">
        <div class="wrapper-card-blog">
          <div class="wrapper-header-card-blog">
            <img src="../../../../assets/images/landing/blogs/image-blog4.png" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label red">
                <span>Igraonica</span>
              </div>
              <span class="time-card-blog">10 min ago</span>
            </div>
            <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
            <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, 1]">Vidi više</span>
          </div>
        </div>
      </div>
      <div class="grid__m-4">
        <div class="wrapper-card-blog">
          <div class="wrapper-header-card-blog">
            <img src="../../../../assets/images/landing/blogs/image-blog5.png" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label blue">
                <span>Torte</span>
              </div>
              <span class="time-card-blog">10 min ago</span>
            </div>
            <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
            <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, 1]">Vidi više</span>
          </div>
        </div>
      </div>
      <div class="grid__m-4">
        <div class="wrapper-card-blog">
          <div class="wrapper-header-card-blog">
            <img src="../../../../assets/images/landing/blogs/image-blog6.png" alt="">
          </div>
          <div class="wrapper-content-card-blog">
            <div class="zc-d-flex zc-align-items">
              <div class="wrapper-category-label green">
                <span>Dekoracija</span>
              </div>
              <span class="time-card-blog">10 min ago</span>
            </div>
            <span class="title-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AI</span>
            <span class="subtitle-landing-blog-card length-character-column length-character-column--2">Humans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AIHumans are much more smarter than AI</span>
            <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, 1]">Vidi više</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
